module.exports = __webpack_public_path__ + "static/media/Logo Bukuku.Club.845ca6aa.png";